import React, { useEffect, useRef } from 'react';

const shapes = [
  { size: 80, top: '15%', left: '8%', delay: '0s', dur: '8s', type: 'diamond' },
  { size: 40, top: '70%', left: '5%', delay: '2s', dur: '11s', type: 'circle' },
  { size: 120, top: '20%', right: '6%', delay: '1s', dur: '9s', type: 'square' },
  { size: 55, top: '60%', right: '8%', delay: '3s', dur: '7s', type: 'diamond' },
  { size: 30, top: '40%', left: '15%', delay: '0.5s', dur: '13s', type: 'circle' },
  { size: 70, top: '80%', right: '18%', delay: '2.5s', dur: '10s', type: 'triangle' },
  { size: 45, top: '10%', left: '40%', delay: '1.5s', dur: '12s', type: 'diamond' },
];

const KentePattern = () => (
  <div style={{
    position: 'absolute', bottom: 0, left: 0, right: 0, height: '4px',
    overflow: 'hidden',
  }}>
    <div style={{
      display: 'flex', width: '200%',
      animation: 'kente-drift 12s linear infinite',
    }}>
      {Array.from({length: 40}).map((_, i) => (
        <div key={i} style={{
          width: '80px', height: '4px', flexShrink: 0,
          background: i % 4 === 0 ? '#F0A500' : i % 4 === 1 ? '#1C1C1A' : i % 4 === 2 ? '#C07D00' : '#111',
        }} />
      ))}
    </div>
  </div>
);

export default function Hero({ onSelectRole }) {
  const titleRef = useRef(null);

  useEffect(() => {
    const el = titleRef.current;
    if (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(32px)';
      setTimeout(() => {
        el.style.transition = 'opacity 0.9s ease, transform 0.9s ease';
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }, 200);
    }
  }, []);

  return (
    <section style={{
      minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '100px 24px 80px',
      position: 'relative', overflow: 'hidden',
      background: 'radial-gradient(ellipse 80% 60% at 50% 30%, rgba(240,165,0,0.06) 0%, transparent 70%), var(--bg)',
    }}>
      {/* Floating shapes */}
      {shapes.map((s, i) => (
        <div key={i} style={{
          position: 'absolute',
          top: s.top, left: s.left, right: s.right,
          width: s.size, height: s.size,
          opacity: 0.05,
          animation: `${i % 2 === 0 ? 'floatUp' : 'floatDown'} ${s.dur} ${s.delay} ease-in-out infinite`,
          border: '1px solid #F0A500',
          borderRadius: s.type === 'circle' ? '50%' : s.type === 'diamond' ? '0' : '4px',
          transform: s.type === 'diamond' ? 'rotate(45deg)' : 'none',
          flexShrink: 0,
        }} />
      ))}

      {/* Grain overlay */}
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.025,
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat', backgroundSize: '150px',
      }} />

      <div style={{ maxWidth: '820px', width: '100%', textAlign: 'center', position: 'relative', zIndex: 2 }} ref={titleRef}>
        {/* Eyebrow */}
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '8px',
          background: 'rgba(240,165,0,0.1)', border: '1px solid rgba(240,165,0,0.25)',
          borderRadius: '100px', padding: '6px 16px',
          marginBottom: '28px',
          fontSize: '0.78rem', fontWeight: '500', letterSpacing: '0.12em',
          textTransform: 'uppercase', color: '#F0A500',
          animation: 'fadeIn 0.6s ease 0.3s both',
        }}>
          <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#F0A500', animation: 'pulse-gold 2s ease infinite' }} />
          Coming Soon — Join the Waitlist
        </div>

        {/* Main headline */}
        <h1 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 'clamp(2.8rem, 7vw, 5.2rem)',
          fontWeight: '600',
          lineHeight: '1.1',
          color: '#fff',
          marginBottom: '8px',
          animation: 'fadeIn 0.8s ease 0.5s both',
        }}>
          Custom Made Fashion
          <br />
          <span style={{
            color: 'var(--gold)',
            fontStyle: 'italic',
            fontWeight: '300',
          }}>Reimagined</span>
          <br />
        </h1>

        {/* Subheadline */}
        <p style={{
          fontSize: 'clamp(1rem, 2.2vw, 1.2rem)',
          color: 'rgba(255,255,255,0.55)',
          maxWidth: '580px', margin: '0 auto 40px',
          lineHeight: '1.7',
          animation: 'fadeIn 0.8s ease 0.7s both',
          fontWeight: '300',
        }}>
          Connect with Ghana's finest tailors — or grow your tailoring business with the tools you've always needed.
        </p>

        {/* CTA Buttons */}
        <div style={{
          display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap',
          marginBottom: '36px',
          animation: 'fadeIn 0.8s ease 0.9s both',
        }}>
          <button onClick={() => onSelectRole('client')} style={{
            background: 'var(--gold)', color: '#000',
            border: 'none', borderRadius: '8px',
            padding: '16px 36px', fontSize: '1rem', fontWeight: '600',
            fontFamily: 'var(--font-sans)', cursor: 'pointer',
            letterSpacing: '0.03em',
            transition: 'all 0.22s ease',
            display: 'flex', alignItems: 'center', gap: '8px',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 12px 32px rgba(240,165,0,0.35)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <span>👗</span> I'm a Client
          </button>
          <button onClick={() => onSelectRole('tailor')} style={{
            background: 'transparent', color: '#fff',
            border: '1px solid rgba(255,255,255,0.25)', borderRadius: '8px',
            padding: '16px 36px', fontSize: '1rem', fontWeight: '500',
            fontFamily: 'var(--font-sans)', cursor: 'pointer',
            letterSpacing: '0.03em',
            transition: 'all 0.22s ease',
            display: 'flex', alignItems: 'center', gap: '8px',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--gold)'; e.currentTarget.style.color = 'var(--gold)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.25)'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            <span>✂️</span> I'm a Tailor
          </button>
        </div>

        {/* Trust line */}
        <div style={{
          fontSize: '0.85rem', color: 'var(--text-dim)',
          animation: 'fadeIn 0.8s ease 1.1s both',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
        }}>
          <div style={{ display: 'flex' }}>
            {['#F0A500','#FFD166','#C07D00'].map((c, i) => (
              <div key={i} style={{
                width: '28px', height: '28px', borderRadius: '50%',
                background: c, border: '2px solid var(--bg)',
                marginLeft: i > 0 ? '-8px' : '0',
              }} />
            ))}
          </div>
          <span>Join <strong style={{ color: 'rgba(255,255,255,0.7)' }}>200+</strong> tailors and clients already on the waitlist</span>
        </div>

        {/* Scroll indicator */}
        <div style={{
          marginTop: '60px',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px',
          opacity: 0.35, animation: 'fadeIn 1s ease 1.5s both',
        }}>
          <span style={{ fontSize: '0.7rem', letterSpacing: '0.15em', textTransform: 'uppercase' }}>Scroll</span>
          <div style={{
            width: '1px', height: '40px',
            background: 'linear-gradient(to bottom, rgba(240,165,0,0.8), transparent)',
            animation: 'floatUp 2s ease-in-out infinite',
          }} />
        </div>
      </div>

      <KentePattern />
    </section>
  );
}
